/**
 * Heuristic GST-rate lookup by HSN/SAC chapter (first 2 digits).
 * NOT authoritative — user should verify against the official GST portal.
 * Returns a Number (0/5/12/18/28) or null if unknown.
 */
export function hsnToTax(code) {
  if (!code) return null;
  const digits = String(code).replace(/\D/g, "");
  if (digits.length < 2) return null;
  const chapter = parseInt(digits.slice(0, 2), 10);
  // SAC (Services): 99xx — mostly 18%
  if (chapter === 99) return 18;
  // Common HSN chapter → GST rate (as per CBIC schedules)
  const map = {
    // Nil / Exempt / 0%
    1: 0, 2: 0, 3: 0, 4: 5, 5: 0, 6: 0, 7: 5, 8: 5, 9: 5, 10: 0,
    11: 5, 12: 5, 13: 5, 14: 5, 15: 5, 16: 12, 17: 5, 18: 18, 19: 18, 20: 12,
    21: 18, 22: 28, 23: 5, 24: 28,
    // Minerals / Fuel
    25: 5, 26: 5, 27: 18,
    // Chemicals / Pharma
    28: 18, 29: 18, 30: 12, 31: 5, 32: 18, 33: 18, 34: 18, 35: 18, 36: 18, 37: 18, 38: 18,
    // Plastics / Rubber
    39: 18, 40: 18,
    // Leather / Fur / Wood
    41: 5, 42: 18, 43: 18, 44: 18, 45: 18, 46: 12,
    // Paper / Books
    47: 12, 48: 18, 49: 0,
    // Textiles
    50: 5, 51: 5, 52: 5, 53: 5, 54: 12, 55: 12, 56: 12, 57: 12, 58: 12, 59: 12,
    60: 12, 61: 12, 62: 12, 63: 5,
    // Footwear / Stone
    64: 18, 65: 18, 66: 18, 67: 18, 68: 18, 69: 18,
    // Glass / Precious
    70: 18, 71: 3,
    // Base metals
    72: 18, 73: 18, 74: 18, 75: 18, 76: 18, 78: 18, 79: 18, 80: 18, 81: 18, 82: 18, 83: 18,
    // Machinery & Electrical (huge chapter)
    84: 18, 85: 18,
    // Vehicles
    86: 18, 87: 28, 88: 18, 89: 5,
    // Instruments / Optical / Medical
    90: 18, 91: 18, 92: 18, 93: 18,
    // Furniture / Toys / Misc
    94: 18, 95: 18, 96: 18, 97: 12, 98: 18,
  };
  return chapter in map ? map[chapter] : null;
}

/**
 * Guess whether a code is Product (HSN) or Service (SAC).
 * SAC codes start with 99.
 */
export function guessKind(code) {
  if (!code) return null;
  const digits = String(code).replace(/\D/g, "");
  if (digits.length < 4) return null;
  return digits.startsWith("99") ? "service" : "product";
}
